/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SystemValueType {
    STRING = 'string',
    STRING_LIST = 'stringList',
    INTEGER = 'integer',
    INTEGER_LIST = 'integerList',
    DECIMAL = 'decimal',
    DECIMAL_LIST = 'decimalList',
    BOOLEAN = 'boolean',
    BOOLEAN_LIST = 'booleanList',
    DATE = 'date',
    DATE_LIST = 'dateList',
    DATE_TIME = 'dateTime',
    DATE_TIME_LIST = 'dateTimeList',
    GUID = 'guid',
    GUID_LIST = 'guidList',
}
